const recharge = (state = {}, action) => {
  switch(action.type){
    case 'ADD_RECHARGE':
      return action.data;

    case 'CLEAR_RECHARGE':
      return null;

    default:
      return state;
  }
}

export default recharge